export default __webpack_public_path__ + "static/media/20.634d3268.png";